import { create } from 'zustand';
import { apiService } from '../services';
import { ComparativeIndividualReportModel } from '../services/reportService';

interface State {
    loadingMarkdown: boolean;
    loadingAccept: boolean;
    loadingVerifyAccept: boolean;
    hasAccept: boolean;
    markdown?: string;
    markdownError: boolean;
    getMarkdown: (data: ComparativeIndividualReportModel) => void;
    hasAcceptBeingBevi: (data: MarkdownRequest) => void;
    acceptBeingBevi: (data: MarkdownRequest) => void;
    clear: () => void;
}

export interface MarkdownRequest {
    formId?: number;
    reportId?: number;
}

export const useBeingBeviStore = create<State>((set) => ({
    loadingMarkdown: false,
    loadingAccept: false,
    loadingVerifyAccept: false,
    hasAccept: false,
    markdownError: false,
    getMarkdown: async (data: ComparativeIndividualReportModel) => {
        try {
            set(() => ({ loadingMarkdown: true }));
            var response = await apiService.post("report/reportMarkdown", data);
            set(() => ({ markdown: response.data.text }));
        } catch (error) {
            set(() => ({ markdownError: true }));
        } finally {
            set(() => ({ loadingMarkdown: false }));
        }
    },
    acceptBeingBevi: async (data: MarkdownRequest) => {
        try {
            set(() => ({ loadingAccept: true }));
            var response = await apiService.post("user/acceptBeingBevi", data);
            set(() => ({ hasAccept: response.data }));
        } catch (error) {
            console.error(error);
        } finally {
            set(() => ({ loadingAccept: false }));
        }
    },
    hasAcceptBeingBevi: async (data: MarkdownRequest) => {
        try {
            set(() => ({ loadingVerifyAccept: true }));
            var response = await apiService.post("user/hasAcceptBeingBevi", data);
            set(() => ({ hasAccept: response.data }));
        } catch (error) {
            console.error(error);
        } finally {
            set(() => ({ loadingVerifyAccept: false }));
        }
    },
    clear: () => {
        set(() => ({ loadingMarkdown: false, markdown: undefined, loadingAccept: false, loadingVerifyAccept: false }))
    }
}))